// // import React, { useState, useEffect, useRef } from 'react';
// // import Chatlogo from '../src/assets/images/Chatlogo.png';
// // import { marked } from 'marked';
 
// // const Chatbot = () => {
// //   const [visible, setVisible] = useState(false);
// //   const [messages, setMessages] = useState([]);
// //   const [input, setInput] = useState('');
// //   const chatboxRef = useRef(null);
 
// //   useEffect(() => {
// //     if (visible && messages.length === 0) {
// //       setTimeout(() => {
// //         addMessage('bot', 'Hi, I’m **SAMSA-BOT**, your assistant. How can I help you today?');
// //       }, 1000);
// //     }
// //   }, [visible]);
 
// //   useEffect(() => {
// //     chatboxRef.current?.scrollTo(0, chatboxRef.current.scrollHeight);
// //   }, [messages]);
 
// //   const addMessage = (sender, text) => {
// //     setMessages(prev => [...prev, { sender, text, time: new Date().toLocaleTimeString() }]);
// //   };
 
// //   const renderMarkdown = (markdown) => {
// //     return { __html: marked.parse(markdown, { breaks: true }) };
// //   };
 
// //   const sendMessage = async () => {
// //     if (!input.trim()) return;
// //     const message = input.trim();
// //     setInput('');
// //     addMessage('user', message);
 
// //     const typingMessage = {
// //       sender: 'bot',
// //       text: 'SAMSA-BOT is typing...',
// //       time: new Date().toLocaleTimeString()
// //     };
// //     setMessages(prev => [...prev, typingMessage]);
 
// //     try {
// //       const aiResponse = await fetch('https://openrouter.ai/api/v1/chat/completions', {
// //         method: 'POST',
// //         headers: {
// //           'Authorization': 'Bearer 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',
// //           'Content-Type': 'application/json',
// //         },
// //         body: JSON.stringify({
// //           model: 'deepseek/deepseek-r1-0528:free',
// //           messages: [
// //             {
// //               role: 'system',
// //               content: `
// // You are **SAMSA-BOT**, an AI assistant for the **South African Maritime Safety Authority (SAMSA)**. Respond professionally, clearly, and helpfully using this official SAMSA context:
 
// // 📘 **About SAMSA**  
// // - Established: 1 April 1998 under SAMSA Act 5 of 1998  
// // - **Mandate**: Safety of life and property at sea, prevent marine pollution, promote SA’s maritime interests  
// // - **Key responsibilities**:
// //   - Small vessel regulation
// //   - LRIT vessel tracking
// //   - Emergency maritime response
 
// // 🎯 **Mission**  
// // _"To promote South Africa's maritime interests and development and position the country as an international Maritime Centre while ensuring maritime safety, health and environmental protection."_
 
// // 👁 **Vision**  
// // _"The Authority Championing South Africa's Global Maritime ambitions."_
 
// // ⚙️ **Core Responsibilities**  
// // - Develop & enforce maritime safety and environmental standards  
// // - Oversee ship operations, inspections & crew certification  
// // - Train and regulate seafarers  
// // - Manage pollution response and search & rescue coordination  
// // - Administer SAFREP ship reporting  
// // - Investigate maritime incidents
 
// // 👥 **Leadership**  
// // - **Chairperson**: Ms. Nthato Minyuku  
// // - **Acting CEO**: Mr. Sobantu Tilayi  
// // - Board Members: Adv. Linda Mahlangu, Dr. Colleen Dardagan, Ms. Pretty Mhlanga, and others
 
// // 🌍 **Corporate Social Investment (CSI)**  
// // - Promotes maritime education & safety awareness  
// // - Focuses on:
// //   - Education
// //   - Water skills development
// //   - Entrepreneurship support  
// // - Supports climate-affected coastal communities
 
// // 🧭 **Social Mapping & Coastal Support**  
// // - Identifies vulnerable coastal areas  
// // - Coordinates stakeholder safety initiatives  
// // - Empowers employees to uphold SAMSA’s values  
// //               `
// //             },
// //             { role: 'user', content: message }
// //           ]
// //         })
// //       });
 
// //       const aiData = await aiResponse.json();
 
// //       if (aiData.error) {
// //         console.error('API Error:', aiData.error);
// //         updateMessage("❌ Sorry, there was an error processing your request.");
// //         return;
// //       }
 
// //       const response = aiData?.choices?.[0]?.message?.content || "⚠️ Sorry, something went wrong.";
// //       updateMessage(response);
// //     } catch (error) {
// //       console.error('SAMSA-BOT error:', error);
// //       updateMessage("🚨 Oops, SAMSA-BOT ran into a problem. Please try again.");
// //     }
// //   };
 
// //   const updateMessage = (text) => {
// //     setMessages(prev => {
// //       const updated = [...prev];
// //       updated[updated.length - 1] = {
// //         sender: 'bot',
// //         text,
// //         time: new Date().toLocaleTimeString()
// //       };
// //       return updated;
// //     });
// //   };
 
// //   const styles = {
// //     chatbotToggle: {
// //       width: '60px',
// //       height: '60px',
// //       backgroundColor: '#009688',
// //       borderRadius: '50%',
// //       boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
// //       backgroundImage: `url(${Chatlogo})`,
// //       backgroundSize: 'contain',
// //       backgroundPosition: 'center',
// //       backgroundRepeat: 'no-repeat',
// //       position: 'fixed',
// //       bottom: '20px',
// //       right: '20px',
// //       zIndex: 9999,
// //       cursor: 'pointer',
// //     },
// //     chatbot: {
// //       position: 'fixed',
// //       bottom: '100px',
// //       right: '20px',
// //       width: '350px',
// //       height: '500px',
// //       background: 'white',
// //       borderRadius: '10px',
// //       boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
// //       display: 'flex',
// //       flexDirection: 'column',
// //       zIndex: 9999,
// //     },
// //     chatHeader: {
// //       backgroundColor: '#009688',
// //       color: 'white',
// //       padding: '10px',
// //       textAlign: 'center',
// //       fontWeight: 'bold',
// //       position: 'relative',
// //     },
// //     chatbox: {
// //       flex: 1,
// //       padding: '10px',
// //       overflowY: 'auto',
// //       display: 'flex',
// //       flexDirection: 'column',
// //       gap: '12px',
// //     },
// //     msgContainer: {
// //       display: 'flex',
// //       flexDirection: 'column',
// //       maxWidth: '80%',
// //     },
// //     bubble: {
// //       padding: '10px',
// //       borderRadius: '10px',
// //       wordWrap: 'break-word',
// //       display: 'inline-block',
// //     },
// //     bubbleUser: {
// //       backgroundColor: '#009688',
// //       color: 'white',
// //       alignSelf: 'flex-end',
// //       textAlign: 'right',
// //       borderBottomRightRadius: 0,
// //     },
// //     bubbleBot: {
// //       backgroundColor: '#e0e0e0',
// //       color: '#333',
// //       alignSelf: 'flex-start',
// //       textAlign: 'left',
// //       borderBottomLeftRadius: 0,
// //     },
// //     time: {
// //       fontSize: '12px',
// //       color: 'gray',
// //       marginTop: '2px',
// //       userSelect: 'none',
// //     },
// //     inputArea: {
// //       display: 'flex',
// //       alignItems: 'center',
// //       padding: '10px',
// //       borderTop: '1px solid #ddd',
// //       gap: '10px',
// //     },
// //     userInput: {
// //       flex: 1,
// //       padding: '10px',
// //       borderRadius: '5px',
// //       border: '1px solid #ccc',
// //       fontSize: '14px',
// //     },
// //     sendBtn: {
// //       width: '60px',
// //       height: '40px',
// //       backgroundColor: '#009688',
// //       color: 'white',
// //       border: 'none',
// //       borderRadius: '5px',
// //       display: 'flex',
// //       alignItems: 'center',
// //       justifyContent: 'center',
// //       cursor: 'pointer',
// //       fontWeight: 'bold',
// //       fontSize: '14px',
// //     },
// //     closeBtn: {
// //       position: 'absolute',
// //       top: '5px',
// //       right: '10px',
// //       background: 'none',
// //       border: 'none',
// //       fontSize: '20px',
// //       color: '#fff',
// //       cursor: 'pointer',
// //     },
// //     clearBtn: {
// //       position: 'absolute',
// //       top: '5px',
// //       left: '10px',
// //       background: 'none',
// //       border: 'none',
// //       fontSize: '20px',
// //       color: '#4CAF50',
// //       cursor: 'pointer',
// //     },
// //   };
 
// //   return (
// //     <>
// //       {!visible && (
// //         <div style={styles.chatbotToggle} onClick={() => setVisible(true)} />
// //       )}
// //       {visible && (
// //         <div style={styles.chatbot}>
// //           <div style={styles.chatHeader}>
// //             SAMSA-BOT AI Assistant
// //             <button style={styles.closeBtn} onClick={() => setVisible(false)}>&times;</button>
// //             <button style={styles.clearBtn} onClick={() => setMessages([])}>🗑️</button>
// //           </div>
// //           <div style={styles.chatbox} ref={chatboxRef}>
// //             {messages.map((msg, idx) => {
// //               const isTyping = msg.text === 'SAMSA-BOT is typing...';
// //               const isBot = msg.sender === 'bot';
// //               return (
// //                 <div
// //                   key={idx}
// //                   style={{
// //                     ...styles.msgContainer,
// //                     alignSelf: isBot ? 'flex-start' : 'flex-end',
// //                   }}
// //                 >
// //                   {isBot ? (
// //                     <div
// //                       style={{ ...styles.bubble, ...styles.bubbleBot }}
// //                       dangerouslySetInnerHTML={renderMarkdown(msg.text)}
// //                     />
// //                   ) : (
// //                     <div style={{ ...styles.bubble, ...styles.bubbleUser }}>
// //                       {msg.text}
// //                     </div>
// //                   )}
// //                   {!isTyping && (
// //                     <div
// //                       style={{
// //                         ...styles.time,
// //                         textAlign: isBot ? 'left' : 'right',
// //                       }}
// //                     >
// //                       {msg.time}
// //                     </div>
// //                   )}
// //                 </div>
// //               );
// //             })}
// //           </div>
// //           <div style={styles.inputArea}>
// //             <input
// //               type="text"
// //               value={input}
// //               onChange={e => setInput(e.target.value)}
// //               onKeyDown={e => e.key === 'Enter' && sendMessage()}
// //               placeholder="Type your message..."
// //               style={styles.userInput}
// //             />
// //             <button style={styles.sendBtn} onClick={sendMessage}>
// //               Send
// //             </button>
// //           </div>
// //         </div>
// //       )}
// //     </>
// //   );
// // };
 
// // export default Chatbot;

// // import React, { useState, useEffect, useRef } from 'react';
// // import Chatlogo from '../src/assets/images/Chatlogo.png';
// // import { marked } from 'marked';
// // import DOMPurify from 'dompurify';
// // import searchIndex from './search-index.json';
 
// // const faqs = [
// //   {
// //     question: 'Hello',
// //     answer: 'How can I help you?'
// //   },
// //    {
// //     question: 'Hi',
// //     answer: 'How can I help you?'
// //   },
// //     {
// //     question: 'Good Day',
// //     answer: 'How can I help you?'
// //   },
// //     {
// //     question: 'Good Afternoon',
// //     answer: 'How can I help you?'
// //   },
// //     {
// //     question: 'Good Evening',
// //     answer: 'How can I help you?'
// //   },
// //     {
// //     question: 'Good Morning',
// //     answer: 'How can I help you?'
// //   },
// //     {
// //     question: 'Hey',
// //      answer: 'How can I help you?'
// //   },
// //     {
// //     question: 'What risk cover is applicable in case of a cadet’s injury or death whilst signed on Articles?',
// //     answer: 'The participating companies/managers are expected to provide their P&I cover which should only extend to repatriation of the cadet. SAMTRA has a Group Personal Accident cover for each cadet which will apply on the cadets return to his home port for any further medical costs that may occur or in event of a loss of limb the cost of rehabilitation and compensation for loss of such limb. Death benefits also apply. In addition, travel insurance cover has been obtained to cover the cadet during travel to /from a vessel.'
// //   },
// //     {
// //     question: 'What contractual arrangements must be concluded to participate?',
// //     answer: 'The following contracts are applicable: SAMTRA –“Owner” (shipping company/manager) Agreement which covers the roles and responsibilities of the parties SAMTRA –Cadet Bursary Agreement. (Provided to the “Owner” for information only “Owner” – Cadet Short term contract of employment which provides more control over cadet performance than Articles of Agreement. '
// //   },
// //     {
// //     question: 'What qualification will cadets obtain on completion of their training?',
// //     answer: 'Cadets will follow an accelerated cadetship which has to be accredited by SAMSA. Participating companies onboard training record books can be used (after accreditation by SAMSA) or SAMSA’s own training record book which is based on the ISF version. Cadets must comply with all SAMSA qualification requirements and once they pass their final Oral examinations, conducted by SAMSA they will be issued with a fully STCW compliant South African Certificate of Competency as Officer of the Watch (Deck or Engine) What training requirements must OOW’s meet in order to obtain higher level Certificates of Competency? Once seatime requirements are met, as per the STCW Code, the candidates are required to attend a further year of studies at a nautical college in South Africa. Once successfully completed and once any additional Ancillary course requirements are met the candidates present themselves for an Oral examination at SAMSA to obtain the next level of Certificate of Competency. Please refer to the diagrams entitled: TRAINING REQUIREMENTS FOR ENGINEER OFFICER, once Qualified as OOW & TRAINING REQUIREMENTS FOR DECK OFFICER, once Qualified as OOW for further information. '
// //   },
// //     {
// //     question: 'What is the employment status of the cadets?',
// //     answer: 'Cadets sign a bursary agreement with SAMTRA to cover the terms of the financial support they receive during their training. The only time an employment contract is deemed to exist is when cadets sign on Articles of Agreement on any vessel on which they serve. Most companies prefer to include a fixed time contract of employment valid only for the period the cadets is signed on Articles to provide greater control and to ensure that their P&I Insurance cover is applicable to the cadets being trained. With an increasing number of shipping companies/managers participating in the project how are cadets to be rotated between companies? The intention is that a cadet will remain with the company providing the berth and undergo onboard training to that company’s standards and will not switch or transfer between companies. This will also be a requirement of SAMSA the Maritime Safety Authority.'
// //   },
// //     {
// //     question: 'When can a new building be registered?',
// //     answer: 'The instance does arise where a new building will be required to be registered for the purpose of registering a mortgage bond prior to the building being completed.  In such instances the surveyor shall evaluate the state of completion of the vessel with reference to the approve plans and particulars, but shall as a minimum confirm that; The hull and principal deck structures are 90% complete The vessel’s main and essential auxiliary machinery is in place All hull fittings are complete (Rudder, shaft, sea cocks etc.) '
// //   },
// //      {
// //     question: "Temporary Pass?",
// //     answer: `The Authority may direct the Registrar to issue a temporary pass in respect of an unregistered ship that is entitled to be registered if the Authority is satisfied by reason of special circumstances permission should be granted for the ship to travel –

// // - From a South African port to a foreign port; or
// // - From a foreign port to another foreign port or to a South African port.

// // The Temporary Pass when issued will display:
// // - the commencement and termination date of the voyage
// // - expiry date of the Temporary Pass
// // - the voyage that the ship is entitled to make.

// // Once the vessel reaches its destination the Temporary Pass is no longer valid and must within a period of 10 days be surrendered to the Registrar of Ships. Failure to do so will result in the Owner / Skipper being fined R20 000.00.`
// //   },


// //     {
// //     question: 'South African National and Resident',
// //    answer: `South African National is defined as-
// // A South African Citizen
// // A South African body corporate established in terms of a law of the Republic with a place of business in the Republic
// // A South African Trust in which
// // The majority of trustees having the controlling power at any given time are South Africa nationals, and
// // A majority of the beneficial interests are held by such South African nationals
// // The Government of the Republic.
// // South African Resident is defined as
// // A natural person whose permanent place of abode is in the Republic
// // A natural person whose domicile is in the Republic
// // A body corporate, wherever incorporated, that has its principal place of business in the Republic (external registered company)
// // A trust which
// // The majority of trustees having the controlling power at any given time are South African residents, and
// // A majority of the beneficial interests are held by such South African residents.
// // NB.  A natural person is any human being as opposed to a legal or juristic person such as companies, closed corporations, statutory bodies etc.`
// //   },
// //     {
// //     question: 'Ships that can be registered',
// //     answer: `South African owned ships, which includes small vessels used for Fishing 
// // Small vessels other than fishing vessels
// // Ships on bareboat charter to South African Nationals being:
// // Ships other than fishing vessels
// // Ships of over 500 gross tonnage
// // Ships propelled by mechanical means and
// // Where the charter agreement is for a period of longer than two years.
// // Ships that cannot be registered
// // Vessels of primitive build
// // Vessel of less than 3 metres in length
// // Vessels registered elsewhere (dual registration) (except as provided for under bareboat charter)
// // Vessels used on inland waters`
// //   },
// //     {
// //     question: 'Ships having South African Nationality are',
// //     answer: `South African registered ship
// // Unregistered ship, being ships entitled to be registered in terms of the Act.
// // Ships that are entitled to be registered are
// // South African owned ships
// // Small vessels, other than fishing vessels that are
// // Wholly owned by South African residents or South African residents and South African nationals; or
// // Operated solely by South African residents or South African nationals or both such residents and such nationals; and
// // Ships on bareboat charter. Being ships that are
// // Vessels other than fishing vessels
// // Vessels of over 500 gross tons
// // Ships propelled by mechanical means and
// // Where the charter agreement is longer than 2 years
// // `
// //   },
// //     {
// //     question: 'Shares',
// //     answer: `For registration; 
// // A ship can be divided into 64 shares and only 64 shares.
// // The number of persons registered as owners of a ship may not at any time exceed 64
// // Any number of persons not exceeding five maybe registered as joint owners of a ship or of one or more shares in a ship
// // A joint owner may not dispose of his or her interest separately
// // A person may not be registered as owner of a fractional part of a share in a ship
// // A body corporate is registered as owner by its name
// // A trust is registered as owner in the name of the trust.
// // `
// //   },
// //     {
// //     question: 'Obligation to report a casualty',
// //     answer: `Marine Notice No. 25 of 2007 – Obligation to report, casualties, accidents & serious injuries.
// // Marine Notice No. 8 of 2011 – “Marine incident Report” for use by small vessels involved in an incident.
// // CASUALTY/ACCIDENT REPORT - for vessel’s for commercial vessels over 25 gross tons
// // `
// //   },
// //     {
// //     question: 'Renewal of Register',
// //     answer: `The period of registration of a ship, excluding vessels on Bareboat charter, unless terminated earlier is valid for a period of 5 years.
// // This 5 year period is calculated from the date the vessel was last registered and the expiry date is indicated on the certificate of South African Registry and will expire at the end of that period unless it is renewed.
// // Where the register is not renewed within the period specified, the registrar will upon expiry of that period make an entry in the register to that effect, and the registration of the ship will be deemed to be closed.
// // Quick Links
// // Check sheet for requirements`
// //   },
// //     {
// //     question: 'Removal from the Register',
// //     answer: `In the case where the Authority has reason to suspect that a registered ship is not entitled to be registered or that it would be inappropriate for the ship to remain on the register having regard
// // To the relevant requirements of the Shipping Act in respect of –
// // The condition of the ship in respect of its safety or any risk of pollution ; and
// // The safety, health and welfare of persons employed or engaged on the ship or
// // To the interests of the Republic or international merchant shipping
// // Top registration requirements that have not been complied with
// // To the registration of any class or description of ships that is prohibited by regulations made by the Minister.
// // The Authority must serve a notice, with the reasons why, on the agent that it intends closing the register after the expiry period of 30 days.  During this period the agent can show good reasons why the register should not be closed.  Alternatively, the agent may consent to the register being closed.  If, after consideration, the Authority is still of the opinion that the ship’s registration is to be closed,  the Authority is to notify the Registrar in writing directing him/her to close the register.
// // De-registration (Deletion)
// // Reasons for the deregistering of a ship are as follows:
// // A registered vessel that
// // Ceases to be entitled to be registered
// // Is burnt or broken up
// // Is taken by an enemy
// // Is actually or constructively lost.
// // The owner/agent must, immediately after obtaining knowledge of the reason, give notice in writing to the Registrar.
// // Such notice should include
// // Letter requesting deletion & giving reason why the vessel is to be deleted with any supporting documentation attached.
// // A copy of the casualty report (if applicable)
// // The original Certificate of South African Registry
// // The applicable for the Deletion.
// // Reasons for deregistration of a ship are as follows:
// // A registered ship that
// // Is either actually or constructively lost
// // Is taken by an enemy
// // Is burnt or broken up
// // Ceases to be entitled to be registered
// // The owner of the ship must, immediately after obtaining knowledge of the reason, give notice in writing to the Registrar. Such notice should include the following:
// // Letter requesting deletion, giving reason why vessel is to be deleted with any supporting documentation
// // A copy of the casualty report (if applicable)
// // The original Certificate of South African Registry
// // Once in receipt of the above the registrar will close the register and issue a deletion certificate.
// // `
// //   },
// //    {
// //     question: 'Registered Agent',
// //     answer: `In respect of every registered ship the name and address of a person must be entered in the register as the registered agent of that ship.  This agent will be the person who serves as the central point of communication between the vessel and this office.  The agent need not be South African, but must be resident in South Africa.
// // In terms of the SRR the registered agent can be-
// // In the case of a ship operated solely by South African residents or South African nationals or both such residents and such nationals, the operator or one of the operators of the ship.
// // In the case of a ship on bareboat charter to South African nationals, the charterer or one of the charterers of the ship
// // In the case of a ship without a managing owner, the person or one of the persons who is the ship’s agent or a person managing the ship
// // In any other case, the managing owner or one of the managing owners.
// // Should the agent or details of the registered agent change the Registrar must be informed in writing within 14 days.
// // `
// //   },
// //     {
// //     question: 'Registration',
// //     answer: `In terms of the South African Ship Registration Act it is not a requirement for vessels that are entitled to be registered and who are operating only in South African waters  to be registered, however where a vessel is not registered it must be licensed.  There are exceptions where vessels must be registered and these are
// // Vessels that trade internationally
// // Where a mortgage bond is to be registered over a vessel
// // To obtain the right to fish under South African jurisdiction, except in the case of less than 25 gross ton fishing vessels.
// // Pleasure vessels undertaking international voyages.
// // Quick Links
// // Application for Registration

// // Check sheet  for Registration of a New Building

// // Registration of a Sport and Recreation Vessel

// // Provisional Registration

// // Existing Vessel purchased overseas


// // `
// //   },

// //    {
// //     question: 'Refusal to register',
// //     answer: `The Registrar may refuse to register a ship on instruction from a Principal Officer if he or she is satisfied that
// // It would be inappropriate for the ship to be registered having regard-
// // To the relevant requirements of the Shipping Acts in respect of –
// // The condition of the ship in respect of its safety or any risk of pollution; and
// // The safety, health and welfare of persons employed or engaged on the ship; or
// // To the interests of the Republic or international merchant shipping
// // The registration requirements that have not been complied with; or
// // Where the registrar has refused registration he or she is to notify the applicant of the refusal in writing.
// // `
// //   },
// //     {
// //     question: 'Pre-registration survey',
// //     answer: `It is a requirement under the Ship Registration Act that prior to a vessel coming onto the South African Ships Register it must have undergone a pre-registration survey.
// // The purpose of the pre-registration survey is
// // To ensure that the vessel actually exists
// // Ensure that the vessel to be registered is in a reputable condition.
// // To prevent owners purchasing a vessel that could never be made compliant with our statutory requirements.
// // The pre-registration survey will cover
// // The condition of the ship in respect of safety and pollution prevention
// // The welfare of her crew in terms of their accommodation
// // It is SAMSA policy that this survey is carried out by a SAMSA surveyor where ever the vessel may be.  If the vessel is not at a South African port then all transport and subsistence costs will be to the owners account.
// // `
// //   }, {
// //     question: 'Pre-registration survey requirements',
// //     answer: `Herewith the list of items that the SAMSA surveyor will look during the pre-registration survey.`
// //   },
// //     {
// //     question: 'Ownership of vessels other than fishing vessels',
// //     answer: `Ownership of vessels other than fishing vessels must be by a
// // South African National or a South African Resident
// // Group of South African National or South African Residents
// // South African National is defined as-
// // A South African Citizen
// // A South African body corporate established in terms of a law of the Republic with a place of business in the Republic
// // A South African Trust in which
// // A majority of the beneficial interests are held by such South African nationals
// // The majority of trustees having the controlling power at any given time are South Africa  nationals, and
// // The Government of the Republic.
// // South African Resident is defined as
// // A natural person whose permanent place of abode is in the Republic
// // A natural person whose domicile is in the Republic
// // A body corporate, wherever incorporated, that has its principal place of business in the Republic (external registered company)
// // A trust which
// // The majority of trustees having the controlling power at any given time are South African residents, and
// // A majority of the beneficial interests are held by such South African residents.
// // NB.  A natural person is any human being as opposed to a legal or juristic person such as companies, closed corporations, statutory bodies etc.
// // `
// //   },
// //    {
// //     question: 'Ownership of fishing vessels',
// //     answer: `To register a fishing vessel the vessel must be wholly owned and controlled, by:
// // One or more South African persons
// // The State
// // Anybody corporate, society or other association of persons incorporated or established under the laws of the Republic and in which the majority of the shares and the voting rights are held and controlled by South African persons.
// // By an Organization established under South African Law
// // A Body corporate designated as an authorized body corporate by the Minister of Environmental Affairs and Tourism Fishing vessels cannot be registered if they are owned by External registered companies
// // South African registered companies or Trusts where the majority shareholders or Trustees are not South African.
// // `
// //   },
// //     {
// //     question: 'IMO Numbers',
// //     answer: `The IMO Ship identification number is a numbering scheme introduced to enhance maritime safety and pollution prevention and to facilitate the prevention of maritime fraud.
// // This scheme applies to seagoing ships of over 100 gross tonnage with the exception of the following
// // Vessels engaged solely in fishing
// // Ships without mechanical means of propulsion;
// // Pleasure yachts
// // Ships engaged on special service;
// // Hopper barges
// // Hydrofoils & hovercraft;
// // Floating docks and structures classified in a similar manner;
// // Ships of war and troop ships; and
// // Wooden ships in general; 
// // It is a unique number issued to a ship and a number that will remain with the vessel until the vessel is permanently withdrawn from service.
// // `
// //   },
// //    {
// //     question: 'Home Ports',
// //     answer: `The home ports are
// // Cape Town
// // Saldanha Bay
// // Mossel Bay
// // Port Elizabeth
// // East London
// // Durban
// // Richards Bay
// // `
// //   },
// //     {
// //     question: 'Certification of foreign registered vessels operating from South Africa',
// //     answer: `Marine Notice`
// //   },
// //    {
// //     question: 'Carving and Marking of a vessel',
// //     answer: `Vessels over 25 gross tons.
// // The markings on a ship with consist of
// // Name
// // Port of registry
// // Official number
// // Gross and if applicable the net tonnage.
// // `
// //   },
// //     {
// //     question: 'Call Sign',
// //     answer: `Issued by ICASA.  Contact details are as follows:
// // Tel: 021 4319800
// // `
// //   },

// //     {
// //     question: 'Bareboat charter',
// //     answer: `Conditions for a vessel to be registered as a bareboat charter are
// // That the:
// // Charterer must be one or more South African Nationals
// // Vessel must be registered in terms of the law of another state
// // Charter contract must be for 2 years or more
// // Vessel cannot be a fishing vessel
// // Vessel must be propelled by mechanical means
// // Vessel must be 500 gross tonnage or more
// // Consent to register under the SA Flag must be given by the State of primary registration
// // Ship owner must give consent.
// // The registration of a vessel on bareboat charter is valid for the period of the charter agreement, unless terminated earlier under the Act or these regulations.
// // `
// //   },
// //   {
// //     question: 'Annual survey of sport and recreation vessels sailing abroad',
// //     answer: `There is a Marine Notice that sets out the guidelines for these vessels. Click on the link below for the Marine Notice to be displayed.
// // Marine Notice

// // `
// //   },
// //   {
// //     question: 'Access to the Register',
// //     answer: `A transcript may be issued to any person on request and payment of the prescribed fee.`
// //   },
// //   {
// //     question: 'How can we become an external surveyor or safety officer?',
// //     answer: `External surveyors are appointed directly by the Principal Officer at your nearest SAMSA port office.  If there is a need in a particular area it would be at the discretion of the PO to recommend an appointment.  This process would need approval from the PO and signed off by the boating manager. A safety officer is appointed by the boating manager through an authorised agency structure. (SADSAA, SALTBAA, SASCA & SA Sailing) 
// // There are two ways of becoming a small vessel surveyor:
// // Joining one of the Authorised agencies to become a Safety officer. (SADSAA, SASCA or SALTBAA)
// // Be appointed as an External SAMSA appointed surveyor by the Local Principal officer at the local SAMSA office.
// // You would need to submit a CV with boating experience as well as qualifications to your local Principal officer. 
// // If there is a need in a particular area for an additional surveyor, the Principal officer will put your name forward to attend the small vessel surveyor course.  There is no fee for the training, however travel etc is at your own expense.  
 
// // If the PO accepts your CV and there is a need for an additional surveyor and you have passed the SAMSA small vessel exam, you would be required to attend surveys with an internal SAMSA surveyor. If found competent you will then by appointed as an external appointed surveyor reporting directly to the local Principal Officer.
// // Safety officers must come from a club structure and will follow similar procedures, however final approval is given by the boating manager.  Safety officers report directly to the authorised agency.
// // `
// //   },
// //   {
// //     question: 'SAMSA forms, checksheets, checklists',
// //     answer: `Click here to view all forms, checksheet, checklists`
// //   },
// // ];
 
// // const Chatbot = () => {
// //   const [visible, setVisible] = useState(false);
// //   const [messages, setMessages] = useState([]);
// //   const [input, setInput] = useState('');
// //   const [faqClicked, setFaqClicked] = useState(false);
// //   const chatboxRef = useRef(null);
 
// //   const flattenedSearchData = Array.isArray(searchIndex)
// //     ? searchIndex
// //     : Object.values(searchIndex).flat();
 
// //   useEffect(() => {
// //     if (visible && messages.length === 0) {
// //       setTimeout(() => {
// //         addMessage('bot', `Hi, I’m **SAMSA-BOT**, your official assistant for the South African Maritime Safety Authority (SAMSA). How can I assist you today?\n\nClick the **FAQs** button for common questions.`);
// //       }, 1000);
// //     }
// //   }, [visible]);
 
// //   useEffect(() => {
// //     chatboxRef.current?.scrollTo(0, chatboxRef.current.scrollHeight);
// //   }, [messages]);
 
// //   const addMessage = (sender, text) => {
// //     setMessages(prev => [...prev, { sender, text, time: new Date().toLocaleTimeString() }]);
// //   };
 
// //   const renderMarkdown = markdown => {
// //     const rawHtml = marked.parse(markdown, { breaks: true });
// //     const htmlWithTarget = rawHtml.replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');
// //     return { __html: DOMPurify.sanitize(htmlWithTarget) };
// //   };
 
// //   const sendMessage = async () => {
// //     if (!input.trim()) return;
// //     const message = input.trim();
// //     setInput('');
// //     addMessage('user', message);
 
// //     const typingMessage = {
// //       sender: 'bot',
// //       text: 'SAMSA-BOT is typing...',
// //       time: new Date().toLocaleTimeString(),
// //     };
// //     setMessages(prev => [...prev, typingMessage]);
 
// //     const results = searchFromIndex(message);
// //     if (results.length > 0) {
// //       const resultMessages = results.slice(0, 3).map(item =>
// //         `🔹 \n${item.snippet} [Read More](${item.link})`
// //       );
// //       updateMessage(`Here’s what I found:\n\n${resultMessages.join('\n\n')}`);
// //       return;
// //     }
 
// //     try {
// //       const aiResponse = await fetch('https://openrouter.ai/api/v1/chat/completions', {
// //         method: 'POST',
// //         headers: {
// //           Authorization: 'Bearer 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',
// //           'Content-Type': 'application/json',
// //         },
// //         body: JSON.stringify({
// //           model: 'deepseek/deepseek-r1-0528:free',
// //           messages: [
// //             {
// //               role: 'system',
// //               content: `
// // You are **SAMSA-BOT**, an AI assistant for the **South African Maritime Safety Authority (SAMSA)**. Respond professionally, clearly, and helpfully using this official SAMSA context:
 
// // 📘 **About SAMSA**
// // - Established: 1 April 1998 under SAMSA Act 5 of 1998
// // - Mandate: Safety of life and property at sea, prevent marine pollution, promote SA’s maritime interests
 
// // 🎯 **Mission**
// // "To promote South Africa's maritime interests and development and position the country as an international Maritime Centre while ensuring maritime safety, health and environmental protection."
 
// // 👁 **Vision**
// // "The Authority Championing South Africa's Global Maritime ambitions."
 
// // ⚙️ **Core Responsibilities**
// // - Develop & enforce maritime safety and environmental standards
// // - Oversee ship operations, inspections & crew certification
// // - Train and regulate seafarers
// // - Manage pollution response and search & rescue coordination
// // - Administer SAFREP ship reporting
// // - Investigate maritime incidents
 
// // 👥 **Leadership**
// // - Chairperson: Ms. Nthato Minyuku
// // - Acting CEO: Mr. Sobantu Tilayi
 
// // 🌍 **Corporate Social Investment (CSI)**
// // - Promotes maritime education & safety awareness
// // - Supports education, water skills development, entrepreneurship
 
// // Respond accurately using SAMSA knowledge base. If unsure, refer users to [Contact Form](/contact-us?section=query-form).`
// //             },
// //             { role: 'user', content: message },
// //           ],
// //         }),
// //       });
 
// //       const aiData = await aiResponse.json();
 
// //       if (aiData.error) {
// //         console.error('API Error:', aiData.error);
// //         updateMessage('❌ Sorry, there was an error processing your request.');
// //         return;
// //       }
 
// //       const response = aiData?.choices?.[0]?.message?.content || '⚠️ Sorry, something went wrong.';
// //       updateMessage(response);
// //     } catch (error) {
// //       console.error('SAMSA-BOT error:', error);
// //       updateMessage('🚨 Oops, SAMSA-BOT ran into a problem. Please try again.');
// //     }
// //   };
 
// //   const updateMessage = text => {
// //     setMessages(prev => {
// //       const updated = [...prev];
// //       updated[updated.length - 1] = {
// //         sender: 'bot',
// //         text,
// //         time: new Date().toLocaleTimeString(),
// //       };
// //       return updated;
// //     });
// //   };
 
// //   const searchFromIndex = query => {
// //     const lowerQuery = query.toLowerCase();
// //     const seenFiles = new Set();
 
// //     return flattenedSearchData.reduce((acc, item) => {
// //       const title = item.title?.toLowerCase() || '';
// //       const content = item.content?.toLowerCase() || '';
 
// //       if ((title.includes(lowerQuery) || content.includes(lowerQuery)) && !seenFiles.has(item.file)) {
// //         seenFiles.add(item.file);
// //         const matchIndex = content.indexOf(lowerQuery);
// //         const snippet = item.content.substring(Math.max(0, matchIndex - 60), matchIndex + 150) + '...';
// //         acc.push({
// //           title: item.title,
// //           link: item.link,
// //           snippet,
// //         });
// //       }
// //       return acc;
// //     }, []);
// //   };
 
// //   const showFAQs = () => {
// //     const faqText = faqs.map((faq, index) => `**Q${index + 1}: ${faq.question}**\n${faq.answer}`).join('\n\n');
// //     addMessage('bot', faqText);
// //     setFaqClicked(true);
// //   };
 
// //   const handleCloseChatbot = () => {
// //     setVisible(false);
// //     setFaqClicked(false);
// //   };
 
// //   const styles = {
// //     chatbotToggle: {
// //       width: '60px',
// //       height: '60px',
// //       backgroundColor: '#009688',
// //       borderRadius: '50%',
// //       boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
// //       backgroundImage: `url(${Chatlogo})`,
// //       backgroundSize: 'contain',
// //       backgroundPosition: 'center',
// //       backgroundRepeat: 'no-repeat',
// //       position: 'fixed',
// //       bottom: '20px',
// //       right: '20px',
// //       zIndex: 9999,
// //       cursor: 'pointer',
// //     },
// //     chatbot: {
// //       position: 'fixed',
// //       bottom: '100px',
// //       right: '20px',
// //       width: '350px',
// //       height: '500px',
// //       background: 'white',
// //       borderRadius: '10px',
// //       boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
// //       display: 'flex',
// //       flexDirection: 'column',
// //       zIndex: 9999,
// //     },
// //     chatHeader: {
// //       backgroundColor: '#009688',
// //       color: 'white',
// //       padding: '10px',
// //       textAlign: 'center',
// //       fontWeight: 'bold',
// //       position: 'relative',
// //     },
// //     chatbox: {
// //       flex: 1,
// //       padding: '10px',
// //       overflowY: 'auto',
// //       display: 'flex',
// //       flexDirection: 'column',
// //       gap: '12px',
// //       position: 'relative',
// //     },
// //     msgContainer: {
// //       display: 'flex',
// //       flexDirection: 'column',
// //       maxWidth: '80%',
// //     },
// //     bubble: {
// //       padding: '10px',
// //       borderRadius: '10px',
// //       wordWrap: 'break-word',
// //       display: 'inline-block',
// //     },
// //     bubbleUser: {
// //       backgroundColor: '#009688',
// //       color: 'white',
// //       alignSelf: 'flex-end',
// //       textAlign: 'right',
// //       borderBottomRightRadius: 0,
// //     },
// //     bubbleBot: {
// //       backgroundColor: '#e0e0e0',
// //       color: '#333',
// //       alignSelf: 'flex-start',
// //       textAlign: 'left',
// //       borderBottomLeftRadius: 0,
// //     },
// //     time: {
// //       fontSize: '12px',
// //       color: 'gray',
// //       marginTop: '2px',
// //       userSelect: 'none',
// //     },
// //     inputArea: {
// //       display: 'flex',
// //       alignItems: 'center',
// //       padding: '10px',
// //       borderTop: '1px solid #ddd',
// //       gap: '10px',
// //     },
// //     userInput: {
// //       flex: 1,
// //       padding: '10px',
// //       borderRadius: '5px',
// //       border: '1px solid #ccc',
// //       fontSize: '14px',
// //     },
// //     sendBtn: {
// //       width: '60px',
// //       height: '40px',
// //       backgroundColor: '#009688',
// //       color: 'white',
// //       border: 'none',
// //       borderRadius: '5px',
// //       display: 'flex',
// //       alignItems: 'center',
// //       justifyContent: 'center',
// //       cursor: 'pointer',
// //       fontWeight: 'bold',
// //       fontSize: '14px',
// //     },
// //     closeBtn: {
// //       position: 'absolute',
// //       top: '5px',
// //       right: '10px',
// //       background: 'none',
// //       border: 'none',
// //       fontSize: '20px',
// //       color: '#fff',
// //       cursor: 'pointer',
// //     },
// //     clearBtn: {
// //       position: 'absolute',
// //       top: '5px',
// //       left: '10px',
// //       background: 'none',
// //       border: 'none',
// //       fontSize: '20px',
// //       color: '#4CAF50',
// //       cursor: 'pointer',
// //     }
// //   };
 
// //   return (
// //     <>
// //       {!visible && <div style={styles.chatbotToggle} onClick={() => setVisible(true)} />}
// //       {visible && (
// //         <div style={styles.chatbot}>
// //           <div style={styles.chatHeader}>
// //             SAMSA-BOT AI Assistant
// //             <button style={styles.closeBtn} onClick={handleCloseChatbot}>&times;</button>
// //             <button style={styles.clearBtn} onClick={() => setMessages([])}>🗑️</button>
// //           </div>
// //           <div style={styles.chatbox} ref={chatboxRef}>
// //             {messages.map((msg, idx) => {
// //               const isTyping = msg.text === 'SAMSA-BOT is typing...';
// //               const isBot = msg.sender === 'bot';
// //               return (
// //                 <div key={idx} style={{ ...styles.msgContainer, alignSelf: isBot ? 'flex-start' : 'flex-end' }}>
// //                   {isBot ? (
// //                     <div style={{ ...styles.bubble, ...styles.bubbleBot }} dangerouslySetInnerHTML={renderMarkdown(msg.text)} />
// //                   ) : (
// //                     <div style={{ ...styles.bubble, ...styles.bubbleUser }}>{msg.text}</div>
// //                   )}
// //                   {!isTyping && (
// //                     <div style={{ ...styles.time, textAlign: isBot ? 'left' : 'right' }}>{msg.time}</div>
// //                   )}
// //                 </div>
// //               );
// //             })}
// //           </div>
         
 
// //           {!faqClicked && (
           
// //             <button
           
// //               onClick={showFAQs}
// //               style={{
// //                 position: 'absolute',
// //                 bottom: '69px',  
// //                 right: '15px',
// //                 backgroundColor: '#4CAF50',
// //                 color: 'white',
// //                 border: 'none',
// //                 borderRadius: '20px',
// //                 padding: '8px 16px',
// //                 fontSize: '14px',
// //                 cursor: 'pointer',
// //                 zIndex: 10000,
// //               }}
// //             >
             
         
// //               FAQs
// //             </button>
           
           
// //           )}
         
 
// //           <div style={styles.inputArea}>
// //             <input
// //               type="text"
// //               value={input}
// //               onChange={e => setInput(e.target.value)}
// //               onKeyDown={e => e.key === 'Enter' && sendMessage()}
// //               placeholder="Type your message..."
// //               style={styles.userInput}
// //             />
// //             <button style={styles.sendBtn} onClick={sendMessage}>Send</button>
// //           </div>
// //         </div>
// //       )}
// //     </>
// //   );
// // };
 
// // export default Chatbot;


//  import React, { useState, useEffect, useRef } from 'react';
// import Chatlogo from '../src/assets/images/Chatlogo.png';
// import { marked } from 'marked';
// import DOMPurify from 'dompurify';
// import searchIndex from './search-index.json';

// const faqs = [

//   {

//     question: 'What risk cover is applicable in case of a cadet’s injury or death whilst signed on Articles?',

//     answer: 'The participating companies/managers are expected to provide their P&I cover which should only extend to repatriation of the cadet. SAMTRA has a Group Personal Accident cover for each cadet which will apply on the cadets return to his home port for any further medical costs that may occur or in event of a loss of limb the cost of rehabilitation and compensation for loss of such limb. Death benefits also apply. In addition, travel insurance cover has been obtained to cover the cadet during travel to /from a vessel.'

//   },

//   {

//     question: 'What contractual arrangements must be concluded to participate?',

//     answer: 'The following contracts are applicable: SAMTRA –“Owner” (shipping company/manager) Agreement which covers the roles and responsibilities of the parties SAMTRA –Cadet Bursary Agreement. (Provided to the “Owner” for information only “Owner” – Cadet Short term contract of employment which provides more control over cadet performance than Articles of Agreement. '

//   },

//   {

//     question: 'What qualification will cadets obtain on completion of their training?',

//     answer: 'Cadets will follow an accelerated cadetship which has to be accredited by SAMSA. Participating companies onboard training record books can be used (after accreditation by SAMSA) or SAMSA’s own training record book which is based on the ISF version. Cadets must comply with all SAMSA qualification requirements and once they pass their final Oral examinations, conducted by SAMSA they will be issued with a fully STCW compliant South African Certificate of Competency as Officer of the Watch (Deck or Engine) What training requirements must OOW’s meet in order to obtain higher level Certificates of Competency? Once seatime requirements are met, as per the STCW Code, the candidates are required to attend a further year of studies at a nautical college in South Africa. Once successfully completed and once any additional Ancillary course requirements are met the candidates present themselves for an Oral examination at SAMSA to obtain the next level of Certificate of Competency. Please refer to the diagrams entitled: TRAINING REQUIREMENTS FOR ENGINEER OFFICER, once Qualified as OOW & TRAINING REQUIREMENTS FOR DECK OFFICER, once Qualified as OOW for further information. '

//   },

//   {

//     question: 'What is the employment status of the cadets?',

//     answer: 'Cadets sign a bursary agreement with SAMTRA to cover the terms of the financial support they receive during their training. The only time an employment contract is deemed to exist is when cadets sign on Articles of Agreement on any vessel on which they serve. Most companies prefer to include a fixed time contract of employment valid only for the period the cadets is signed on Articles to provide greater control and to ensure that their P&I Insurance cover is applicable to the cadets being trained. With an increasing number of shipping companies/managers participating in the project how are cadets to be rotated between companies? The intention is that a cadet will remain with the company providing the berth and undergo onboard training to that company’s standards and will not switch or transfer between companies. This will also be a requirement of SAMSA the Maritime Safety Authority.'

//   },

//   {

//     question: 'When can a new building be registered?',

//     answer: 'The instance does arise where a new building will be required to be registered for the purpose of registering a mortgage bond prior to the building being completed.  In such instances the surveyor shall evaluate the state of completion of the vessel with reference to the approve plans and particulars, but shall as a minimum confirm that; The hull and principal deck structures are 90% complete The vessel’s main and essential auxiliary machinery is in place All hull fittings are complete (Rudder, shaft, sea cocks etc.) '

//   },

//   {

//     question: "Temporary Pass?",

//     answer: `The Authority may direct the Registrar to issue a temporary pass in respect of an unregistered ship that is entitled to be registered if the Authority is satisfied by reason of special circumstances permission should be granted for the ship to travel –

 

// - From a South African port to a foreign port; or

// - From a foreign port to another foreign port or to a South African port.

 

// The Temporary Pass when issued will display:

// - the commencement and termination date of the voyage

// - expiry date of the Temporary Pass

// - the voyage that the ship is entitled to make.

 

// Once the vessel reaches its destination the Temporary Pass is no longer valid and must within a period of 10 days be surrendered to the Registrar of Ships. Failure to do so will result in the Owner / Skipper being fined R20 000.00.`

//   },





//   {

//     question: 'South African National and Resident',

//     answer: `South African National is defined as-

// A South African Citizen

// A South African body corporate established in terms of a law of the Republic with a place of business in the Republic

// A South African Trust in which

// The majority of trustees having the controlling power at any given time are South Africa nationals, and

// A majority of the beneficial interests are held by such South African nationals

// The Government of the Republic.

// South African Resident is defined as

// A natural person whose permanent place of abode is in the Republic

// A natural person whose domicile is in the Republic

// A body corporate, wherever incorporated, that has its principal place of business in the Republic (external registered company)

// A trust which

// The majority of trustees having the controlling power at any given time are South African residents, and

// A majority of the beneficial interests are held by such South African residents.

// NB.  A natural person is any human being as opposed to a legal or juristic person such as companies, closed corporations, statutory bodies etc.`

//   },

//   {

//     question: 'Ships that can be registered',

//     answer: `South African owned ships, which includes small vessels used for Fishing

// Small vessels other than fishing vessels

// Ships on bareboat charter to South African Nationals being:

// Ships other than fishing vessels

// Ships of over 500 gross tonnage

// Ships propelled by mechanical means and

// Where the charter agreement is for a period of longer than two years.

// Ships that cannot be registered

// Vessels of primitive build

// Vessel of less than 3 metres in length

// Vessels registered elsewhere (dual registration) (except as provided for under bareboat charter)

// Vessels used on inland waters`

//   },

//   {

//     question: 'Ships having South African Nationality are',

//     answer: `South African registered ship

// Unregistered ship, being ships entitled to be registered in terms of the Act.

// Ships that are entitled to be registered are

// South African owned ships

// Small vessels, other than fishing vessels that are

// Wholly owned by South African residents or South African residents and South African nationals; or

// Operated solely by South African residents or South African nationals or both such residents and such nationals; and

// Ships on bareboat charter. Being ships that are

// Vessels other than fishing vessels

// Vessels of over 500 gross tons

// Ships propelled by mechanical means and

// Where the charter agreement is longer than 2 years

// `

//   },

//   {

//     question: 'Shares',

//     answer: `For registration;

// A ship can be divided into 64 shares and only 64 shares.

// The number of persons registered as owners of a ship may not at any time exceed 64

// Any number of persons not exceeding five maybe registered as joint owners of a ship or of one or more shares in a ship

// A joint owner may not dispose of his or her interest separately

// A person may not be registered as owner of a fractional part of a share in a ship

// A body corporate is registered as owner by its name

// A trust is registered as owner in the name of the trust.

// `

//   },

//   {

//     question: 'Obligation to report a casualty',

//     answer: `Marine Notice No. 25 of 2007 – Obligation to report, casualties, accidents & serious injuries.

// Marine Notice No. 8 of 2011 – “Marine incident Report” for use by small vessels involved in an incident.

// CASUALTY/ACCIDENT REPORT - for vessel’s for commercial vessels over 25 gross tons

// `

//   },

//   {

//     question: 'Renewal of Register',

//     answer: `The period of registration of a ship, excluding vessels on Bareboat charter, unless terminated earlier is valid for a period of 5 years.

// This 5 year period is calculated from the date the vessel was last registered and the expiry date is indicated on the certificate of South African Registry and will expire at the end of that period unless it is renewed.

// Where the register is not renewed within the period specified, the registrar will upon expiry of that period make an entry in the register to that effect, and the registration of the ship will be deemed to be closed.

// Quick Links

// Check sheet for requirements`

//   },

//   {

//     question: 'Removal from the Register',

//     answer: `In the case where the Authority has reason to suspect that a registered ship is not entitled to be registered or that it would be inappropriate for the ship to remain on the register having regard

// To the relevant requirements of the Shipping Act in respect of –

// The condition of the ship in respect of its safety or any risk of pollution ; and

// The safety, health and welfare of persons employed or engaged on the ship or

// To the interests of the Republic or international merchant shipping

// Top registration requirements that have not been complied with

// To the registration of any class or description of ships that is prohibited by regulations made by the Minister.

// The Authority must serve a notice, with the reasons why, on the agent that it intends closing the register after the expiry period of 30 days.  During this period the agent can show good reasons why the register should not be closed.  Alternatively, the agent may consent to the register being closed.  If, after consideration, the Authority is still of the opinion that the ship’s registration is to be closed,  the Authority is to notify the Registrar in writing directing him/her to close the register.

// De-registration (Deletion)

// Reasons for the deregistering of a ship are as follows:

// A registered vessel that

// Ceases to be entitled to be registered

// Is burnt or broken up

// Is taken by an enemy

// Is actually or constructively lost.

// The owner/agent must, immediately after obtaining knowledge of the reason, give notice in writing to the Registrar.

// Such notice should include

// Letter requesting deletion & giving reason why the vessel is to be deleted with any supporting documentation attached.

// A copy of the casualty report (if applicable)

// The original Certificate of South African Registry

// The applicable for the Deletion.

// Reasons for deregistration of a ship are as follows:

// A registered ship that

// Is either actually or constructively lost

// Is taken by an enemy

// Is burnt or broken up

// Ceases to be entitled to be registered

// The owner of the ship must, immediately after obtaining knowledge of the reason, give notice in writing to the Registrar. Such notice should include the following:

// Letter requesting deletion, giving reason why vessel is to be deleted with any supporting documentation

// A copy of the casualty report (if applicable)

// The original Certificate of South African Registry

// Once in receipt of the above the registrar will close the register and issue a deletion certificate.

// `

//   },

//   {

//     question: 'Registered Agent',

//     answer: `In respect of every registered ship the name and address of a person must be entered in the register as the registered agent of that ship.  This agent will be the person who serves as the central point of communication between the vessel and this office.  The agent need not be South African, but must be resident in South Africa.

// In terms of the SRR the registered agent can be-

// In the case of a ship operated solely by South African residents or South African nationals or both such residents and such nationals, the operator or one of the operators of the ship.

// In the case of a ship on bareboat charter to South African nationals, the charterer or one of the charterers of the ship

// In the case of a ship without a managing owner, the person or one of the persons who is the ship’s agent or a person managing the ship

// In any other case, the managing owner or one of the managing owners.

// Should the agent or details of the registered agent change the Registrar must be informed in writing within 14 days.

// `

//   },

//   {

//     question: 'Registration',

//     answer: `In terms of the South African Ship Registration Act it is not a requirement for vessels that are entitled to be registered and who are operating only in South African waters  to be registered, however where a vessel is not registered it must be licensed.  There are exceptions where vessels must be registered and these are

// Vessels that trade internationally

// Where a mortgage bond is to be registered over a vessel

// To obtain the right to fish under South African jurisdiction, except in the case of less than 25 gross ton fishing vessels.

// Pleasure vessels undertaking international voyages.

// Quick Links

// Application for Registration

 

// Check sheet  for Registration of a New Building

 

// Registration of a Sport and Recreation Vessel

 

// Provisional Registration

 

// Existing Vessel purchased overseas

 

 

// `

//   },



//   {

//     question: 'Refusal to register',

//     answer: `The Registrar may refuse to register a ship on instruction from a Principal Officer if he or she is satisfied that

// It would be inappropriate for the ship to be registered having regard-

// To the relevant requirements of the Shipping Acts in respect of –

// The condition of the ship in respect of its safety or any risk of pollution; and

// The safety, health and welfare of persons employed or engaged on the ship; or

// To the interests of the Republic or international merchant shipping

// The registration requirements that have not been complied with; or

// Where the registrar has refused registration he or she is to notify the applicant of the refusal in writing.

// `

//   },

//   {

//     question: 'Pre-registration survey',

//     answer: `It is a requirement under the Ship Registration Act that prior to a vessel coming onto the South African Ships Register it must have undergone a pre-registration survey.

// The purpose of the pre-registration survey is

// To ensure that the vessel actually exists

// Ensure that the vessel to be registered is in a reputable condition.

// To prevent owners purchasing a vessel that could never be made compliant with our statutory requirements.

// The pre-registration survey will cover

// The condition of the ship in respect of safety and pollution prevention

// The welfare of her crew in terms of their accommodation

// It is SAMSA policy that this survey is carried out by a SAMSA surveyor where ever the vessel may be.  If the vessel is not at a South African port then all transport and subsistence costs will be to the owners account.

// `

//   }, {

//     question: 'Pre-registration survey requirements',

//     answer: `Herewith the list of items that the SAMSA surveyor will look during the pre-registration survey.`

//   },

//   {

//     question: 'Ownership of vessels other than fishing vessels',

//     answer: `Ownership of vessels other than fishing vessels must be by a

// South African National or a South African Resident

// Group of South African National or South African Residents

// South African National is defined as-

// A South African Citizen

// A South African body corporate established in terms of a law of the Republic with a place of business in the Republic

// A South African Trust in which

// A majority of the beneficial interests are held by such South African nationals

// The majority of trustees having the controlling power at any given time are South Africa  nationals, and

// The Government of the Republic.

// South African Resident is defined as

// A natural person whose permanent place of abode is in the Republic

// A natural person whose domicile is in the Republic

// A body corporate, wherever incorporated, that has its principal place of business in the Republic (external registered company)

// A trust which

// The majority of trustees having the controlling power at any given time are South African residents, and

// A majority of the beneficial interests are held by such South African residents.

// NB.  A natural person is any human being as opposed to a legal or juristic person such as companies, closed corporations, statutory bodies etc.

// `

//   },

//   {

//     question: 'Ownership of fishing vessels',

//     answer: `To register a fishing vessel the vessel must be wholly owned and controlled, by:

// One or more South African persons

// The State

// Anybody corporate, society or other association of persons incorporated or established under the laws of the Republic and in which the majority of the shares and the voting rights are held and controlled by South African persons.

// By an Organization established under South African Law

// A Body corporate designated as an authorized body corporate by the Minister of Environmental Affairs and Tourism Fishing vessels cannot be registered if they are owned by External registered companies

// South African registered companies or Trusts where the majority shareholders or Trustees are not South African.

// `

//   },

//   {

//     question: 'IMO Numbers',

//     answer: `The IMO Ship identification number is a numbering scheme introduced to enhance maritime safety and pollution prevention and to facilitate the prevention of maritime fraud.

// This scheme applies to seagoing ships of over 100 gross tonnage with the exception of the following

// Vessels engaged solely in fishing

// Ships without mechanical means of propulsion;

// Pleasure yachts

// Ships engaged on special service;

// Hopper barges

// Hydrofoils & hovercraft;

// Floating docks and structures classified in a similar manner;

// Ships of war and troop ships; and

// Wooden ships in general;

// It is a unique number issued to a ship and a number that will remain with the vessel until the vessel is permanently withdrawn from service.

// `

//   },

//   {

//     question: 'Home Ports',

//     answer: `The home ports are

// Cape Town

// Saldanha Bay

// Mossel Bay

// Port Elizabeth

// East London

// Durban

// Richards Bay

// `

//   },

//   {

//     question: 'Certification of foreign registered vessels operating from South Africa',

//     answer: `Marine Notice`

//   },

//   {

//     question: 'Carving and Marking of a vessel',

//     answer: `Vessels over 25 gross tons.

// The markings on a ship with consist of

// Name

// Port of registry

// Official number

// Gross and if applicable the net tonnage.

// `

//   },

//   {

//     question: 'Call Sign',

//     answer: `Issued by ICASA.  Contact details are as follows:

// Tel: 021 4319800

// `

//   },



//   {

//     question: 'Bareboat charter',

//     answer: `Conditions for a vessel to be registered as a bareboat charter are

// That the:

// Charterer must be one or more South African Nationals

// Vessel must be registered in terms of the law of another state

// Charter contract must be for 2 years or more

// Vessel cannot be a fishing vessel

// Vessel must be propelled by mechanical means

// Vessel must be 500 gross tonnage or more

// Consent to register under the SA Flag must be given by the State of primary registration

// Ship owner must give consent.

// The registration of a vessel on bareboat charter is valid for the period of the charter agreement, unless terminated earlier under the Act or these regulations.

// `

//   },

//   {

//     question: 'Annual survey of sport and recreation vessels sailing abroad',

//     answer: `There is a Marine Notice that sets out the guidelines for these vessels. Click on the link below for the Marine Notice to be displayed.

// Marine Notice

 

// `

//   },

//   {

//     question: 'Access to the Register',

//     answer: `A transcript may be issued to any person on request and payment of the prescribed fee.`

//   },

//   {

//     question: 'How can we become an external surveyor or safety officer?',

//     answer: `External surveyors are appointed directly by the Principal Officer at your nearest SAMSA port office.  If there is a need in a particular area it would be at the discretion of the PO to recommend an appointment.  This process would need approval from the PO and signed off by the boating manager. A safety officer is appointed by the boating manager through an authorised agency structure. (SADSAA, SALTBAA, SASCA & SA Sailing)

// There are two ways of becoming a small vessel surveyor:

// Joining one of the Authorised agencies to become a Safety officer. (SADSAA, SASCA or SALTBAA)

// Be appointed as an External SAMSA appointed surveyor by the Local Principal officer at the local SAMSA office.

// You would need to submit a CV with boating experience as well as qualifications to your local Principal officer.

// If there is a need in a particular area for an additional surveyor, the Principal officer will put your name forward to attend the small vessel surveyor course.  There is no fee for the training, however travel etc is at your own expense. 

 

// If the PO accepts your CV and there is a need for an additional surveyor and you have passed the SAMSA small vessel exam, you would be required to attend surveys with an internal SAMSA surveyor. If found competent you will then by appointed as an external appointed surveyor reporting directly to the local Principal Officer.

// Safety officers must come from a club structure and will follow similar procedures, however final approval is given by the boating manager.  Safety officers report directly to the authorised agency.

// `

//   },

//   {

//     question: 'SAMSA forms, checksheets, checklists',

//     answer: `Click here to view all forms, checksheet, checklists`

//   },

// ];

// const Chatbot = () => {
//   const [visible, setVisible] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [input, setInput] = useState('');
//   const [showFaqPanel, setShowFaqPanel] = useState(false);
//   const [showAllFaqs, setShowAllFaqs] = useState(false);
//   const chatboxRef = useRef(null);

//   const flattenedSearchData = Array.isArray(searchIndex)
//     ? searchIndex
//     : Object.values(searchIndex).flat();

//   useEffect(() => {
//     if (visible && messages.length === 0) {
//       const timer = setTimeout(() => {
//         addMessage(
//           'bot',
//           `Hi, I’m **Captain Quirky.** I am your official assistant here to help you navigate the SAMSA website. How can I help you today!\n\nClick the **FAQs** button to view common questions.`
//         );
//       }, 1000);
//       return () => clearTimeout(timer);
//     }
//   }, [visible]);

//   useEffect(() => {
//     chatboxRef.current?.scrollTo(0, chatboxRef.current.scrollHeight);
//   }, [messages]);

//   const addMessage = (sender, text) => {
//     setMessages((prev) => [
//       ...prev,
//       { sender, text, time: new Date().toLocaleTimeString() },
//     ]);
//   };

//   const renderMarkdown = (markdown) => {
//     const rawHtml = marked.parse(markdown, { breaks: true });
//     const htmlWithTarget = rawHtml.replace(
//       /<a /g,
//       '<a target="_blank" rel="noopener noreferrer" '
//     );
//     return { __html: DOMPurify.sanitize(htmlWithTarget) };
//   };

//   const sendMessage = async () => {
//     if (!input.trim()) return;
//     const message = input.trim();
//     setInput('');
//     addMessage('user', message);

//     const typingMessage = {
//       sender: 'bot',
//       text: 'SAMSA-BOT is typing...',
//       time: new Date().toLocaleTimeString(),
//     };
//     setMessages((prev) => [...prev, typingMessage]);

//     const results = searchFromIndex(message);
//     if (results.length > 0) {
//       const resultMessages = results
//         .slice(0, 3)
//         .map((item) => `🔹 \n${item.snippet} [Read More](${item.link})`);
//       updateMessage(`Here’s what I found:\n\n${resultMessages.join('\n\n')}`);
//       return;
//     }



//     try {
//       const aiResponse = await fetch(
//         'https://openrouter.ai/api/v1/chat/completions',
//         {
//           method: 'POST',
//           headers: {
//             'Authorization': 'Bearer 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',
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             model: 'deepseek/deepseek-r1-0528-qwen3-8b:free',
//             messages: [
//               {
//                 role: 'system',
//                 content: `You are **SAMSA-BOT**, an AI assistant for the **South African Maritime Safety Authority (SAMSA)**. Respond professionally, clearly, and helpfully using this official SAMSA 
//                 context:
 
//  📘 **About SAMSA**  
//  - Established: 1 April 1998 under SAMSA Act 5 of 1998  
//  - **Mandate**: Safety of life and property at sea, prevent marine pollution, promote SA’s maritime interests  
//  - **Key responsibilities**:
//    - Small vessel regulation
//    - LRIT vessel tracking
//    - Emergency maritime response
 
//  🎯 **Mission**  
//  _"To promote South Africa's maritime interests and development and position the country as an international Maritime Centre while ensuring maritime safety, health and environmental protection."_
 
//  👁 **Vision**  
//  _"The Authority Championing South Africa's Global Maritime ambitions."_
 
//  ⚙️ **Core Responsibilities**  
//  - Develop & enforce maritime safety and environmental standards  
//  - Oversee ship operations, inspections & crew certification  
//  - Train and regulate seafarers  
//  - Manage pollution response and search & rescue coordination  
//  - Administer SAFREP ship reporting  
//  - Investigate maritime incidents
 
//  👥 **Leadership**  
//  - **Chairperson**: Ms. Nthato Minyuku  
//  - **Acting CEO**: Mr. Sobantu Tilayi  
//  - Board Members: Adv. Linda Mahlangu, Dr. Colleen Dardagan, Ms. Pretty Mhlanga, and others
 
//  🌍 **Corporate Social Investment (CSI)**  
//  - Promotes maritime education & safety awareness  
//  - Focuses on:
//    - Education
//    - Water skills development
//    - Entrepreneurship support  
//  - Supports climate-affected coastal communities
 
//  🧭 **Social Mapping & Coastal Support**  

//  - Identifies vulnerable coastal areas  
//  - Coordinates stakeholder safety initiatives  
//  - Empowers employees to uphold SAMSA’s values
 
// **Always give this answer**: Please [<span style="color: green;">submit your query here](/contact-us?section=query-form).</span> if you didn't understand the query/question or the user asked what is not SAMSA related.
//                ` },
//               { role: 'user', content: message },
//             ],
//           }),
//         }
//       );

// const handleSend = (question) => {
//   const faq = faqs.find(
//     (faq) => faq.question.toLowerCase() === question.toLowerCase()
//   );

//   let answer = faq ? faq.answer : "I'm not sure about that.";

//   // ✅ Now apply the SAMSA check
//   let botResponse = answer;
//   if (!botResponse.toLowerCase().includes("samsa")) {
//     botResponse +=
//       " Please [submit your query here](/contact-us?section=query-form)";
//   }

//   setMessages((prev) => [
//     ...prev,
//     { sender: "user", text: question },
//     { sender: "bot", text: botResponse },
//   ]);
// };

//       const aiData = await aiResponse.json();
//       if (aiData.error) {
//         updateMessage('❌ Sorry, there was an error processing your request.  Please [submit your query here](/contact-us?section=query-form)');
//         return;
//       }

//       const response =
//         aiData?.choices?.[0]?.message?.content || '⚠️ Sorry, something went wrong.';
//       updateMessage(response);
//     } catch (error) {
//       console.error('SAMSA-BOT error:', error);
//       updateMessage('🚨 Oops, SAMSA-BOT ran into a problem. Please [submit your query here](/contact-us?section=query-form)');
//     }
//   };

//   const updateMessage = (text) => {
//     setMessages((prev) => {
//       const updated = [...prev];
//       updated[updated.length - 1] = {
//         sender: 'bot',
//         text,
//         time: new Date().toLocaleTimeString(),
//       };
//       return updated;
//     });
//   };

//   const searchFromIndex = (query) => {
//     const lowerQuery = query.toLowerCase();
//     const seenFiles = new Set();

//     return flattenedSearchData.reduce((acc, item) => {
//       const title = item.title?.toLowerCase() || '';
//       const content = item.content?.toLowerCase() || '';
//       if ((title.includes(lowerQuery) || content.includes(lowerQuery)) && !seenFiles.has(item.file)) {
//         seenFiles.add(item.file);
//         const matchIndex = content.indexOf(lowerQuery);
//         const snippet =
//           item.content.substring(Math.max(0, matchIndex - 60), matchIndex + 150) + '...';
//         acc.push({ title: item.title, link: item.link, snippet });
//       }
//       return acc;
//     }, []);
//   };

//   const toggleFaqPanel = () => {
//     setShowFaqPanel(!showFaqPanel);
//     setShowAllFaqs(false);
//   };

//   const handleFaqClick = (faq) => {
//     addMessage('user', faq.question);
//     setShowFaqPanel(false);
//     setShowAllFaqs(false);
//     setTimeout(() => {
//       addMessage('bot', faq.answer);
//     }, 400);
//   };

//   const visibleFaqs = showAllFaqs ? faqs : faqs.slice(0, 5);

//   const styles = {
//     chatbotToggle: {
//       width: '60px',
//       height: '60px',
//       backgroundColor: '#009688',
//       borderRadius: '50%',
//       boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
//       backgroundImage: `url(${Chatlogo})`,
//       backgroundSize: 'contain',
//       backgroundPosition: 'center',
//       backgroundRepeat: 'no-repeat',
//       position: 'fixed',
//       bottom: '20px',
//       right: '20px',
//       zIndex: 9999,
//       cursor: 'pointer',
//     },
//     chatbot: {
//       position: 'fixed',
//       bottom: '100px',
//       right: '20px',
//       width: '350px',
//       height: '500px',
//       background: 'white',
//       borderRadius: '10px',
//       boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
//       display: 'flex',
//       flexDirection: 'column',
//       zIndex: 9999,
//     },
//     chatHeader: {
//       backgroundColor: '#009688',
//       color: 'white',
//       padding: '10px',
//       textAlign: 'center',
//       fontWeight: 'bold',
//       position: 'relative',
//     },
//     chatbox: {
//       flex: 1,
//       padding: '10px',
//       overflowY: 'auto',
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '12px',
//     },
//     inputArea: {
//       display: 'flex',
//       alignItems: 'center',
//       padding: '10px',
//       borderTop: '1px solid #ddd',
//       gap: '10px',
//       position: 'relative',
//     },
//     userInput: {
//       flex: 1,
//       padding: '10px',
//       borderRadius: '5px',
//       border: '1px solid #ccc',
//       fontSize: '14px',
//     },
//     sendBtn: {
//       width: '60px',
//       height: '40px',
//       backgroundColor: '#009688',
//       color: 'white',
//       border: 'none',
//       borderRadius: '5px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       cursor: 'pointer',
//       fontWeight: 'bold',
//       fontSize: '14px',
//     },
//     faqToggleBtn: {
//       backgroundColor: '#4CAF50',
//       color: 'white',
//       border: 'none',
//       borderRadius: '20px',
//       padding: '6px 14px',
//       cursor: 'pointer',
//       fontSize: '14px',
//       position: 'absolute',
//       right: '18px',
//       bottom: '75px',
//     },
//     faqPanel: {
//       position: 'absolute',
//       bottom: '50px',
//       right: '0',
//       width: '100%',
//       maxHeight: '200px',
//       overflowY: 'auto',
//       border: '1px solid #ddd',
//       borderRadius: '8px',
//       background: '#f9f9f9',
//       zIndex: 9999,
//     },
//     faqItem: {
//       marginBottom: '8px',
//       padding: '8px 12px',
//       borderRadius: '8px',
//       background: '#eee',
//       cursor: 'pointer',
//       fontWeight: 'bold',
//       color: '#009688',
//     },
//   };

//   return (
//     <>
//       {!visible && <div style={styles.chatbotToggle} onClick={() => setVisible(true)} />}
//       {visible && (
//         <div style={styles.chatbot}>
//           <div style={styles.chatHeader}>
//             {/* SAMSA-BOT AI Assistant */}
//             Captain Quirky
//             <button
//               style={{
//                 position: 'absolute',
//                 top: '5px',
//                 right: '10px',
//                 background: 'none',
//                 border: 'none',
//                 fontSize: '20px',
//                 color: '#fff',
//                 cursor: 'pointer',
//               }}
//               onClick={() => setVisible(false)}
//             >
//               &times;
//             </button>
//           </div>

//           <div style={styles.chatbox} ref={chatboxRef}>
//             {messages.map((msg, idx) => {
//               const isBot = msg.sender === 'bot';
//               return (
//                 <div
//                   key={idx}
//                   style={{
//                     alignSelf: isBot ? 'flex-start' : 'flex-end',
//                     maxWidth: '80%',
//                   }}
//                 >
//                   {isBot ? (
//                     <div
//                       style={{
//                         background: '#bfbfbf',
//                         padding: '8px',
//                         borderRadius: '10px',
//                       }}
//                       dangerouslySetInnerHTML={renderMarkdown(msg.text)}
                       
//                     />
//                   ) : (
//                     <div
//                       style={{
//                         background: '#009688',
//                         color: 'white',
//                         padding: '8px',
//                         borderRadius: '10px',
//                       }}
//                     >
//                       {msg.text}
//                     </div>
//                   )}
//                   <div
//                     style={{
//                       fontSize: '11px',
//                       color: 'gray',
//                       textAlign: isBot ? 'left' : 'right',
//                     }}
//                   >
//                     {msg.time}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           <div style={styles.inputArea}>
//             <input
//               type="text"
//               value={input}
//               onChange={(e) => setInput(e.target.value)}
//               onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
//               placeholder="Type your message..."
//               style={styles.userInput}
//             />
//             <button style={styles.sendBtn} onClick={sendMessage}>
//               Send
//             </button>

//             <button style={styles.faqToggleBtn} onClick={toggleFaqPanel}>
//               {showFaqPanel ? 'Hide FAQs' : 'FAQs'}
//             </button>

//             {showFaqPanel && (
//               <div style={styles.faqPanel}>
//                 {visibleFaqs.map((faq, index) => (
//                   <div
//                     key={index}
//                     style={styles.faqItem}
//                     onClick={() => handleFaqClick(faq)}
//                   >
//                     {faq.question}
//                   </div>
//                 ))}
//                 {faqs.length > 5 && (
//                   <button
//                     style={{
//                       ...styles.faqToggleBtn,
//                       position: 'relative',
//                       bottom: 'auto',
//                       right: 'auto',
//                       margin: '5px auto',
//                     }}
//                     onClick={() => setShowAllFaqs(!showAllFaqs)}
//                   >
//                     {showAllFaqs ? 'Show Less' : 'Show More'}
//                   </button>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Chatbot;



import React, { useState, useEffect, useRef } from "react";
import { WebApiURL } from "./Constants/Constants";
import Chatlogo from "../src/assets/images/Chatlogo.png";
import { marked } from "marked";
import DOMPurify from "dompurify";

const faqs = [
  {
    question: "What risk cover is applicable in case of a cadet’s injury or death whilst signed on Articles?",
    answer: `Participating companies provide P&I cover for repatriation. SAMTRA has Group Personal Accident cover for medical costs, rehabilitation, and death benefits.  
[Read More](http://www.samsa.org.za/faq-s)`,
  },
  {
    question: "What contractual arrangements must be concluded to participate?",
    answer: `Required contracts include SAMTRA–Owner Agreement, SAMTRA–Cadet Bursary Agreement, and Owner–Cadet Short-term Employment Contract.  
[Read More](http://www.samsa.org.za/faq-s)`,
  },
  {
    question: "When can a new building be registered?",
    answer: `A new building may be registered once the hull and principal deck structures are 90% complete, main and auxiliary machinery are installed, and hull fittings are complete.  
[Read More](http://www.samsa.org.za/Check%20Sheet%20%20Forms/REGISTRATION%20%20OF%20SPORT%20AND%20REC%20PLEASURE%20VESSELS/Registration_of_sport_and_rec_pleasure_vessels.pdf)`,
  },
  {
    question: "Temporary Pass?",
    answer: `A Temporary Pass allows unregistered ships to travel under special circumstances and must be surrendered within 10 days after arrival.  
[Read More](http://www.samsa.org.za/faq-s)`,
  },
  {
    question: "How can we become an external surveyor or safety officer?",
    answer: `Submit your CV to the local Principal Officer. If approved, you’ll attend a small vessel surveyor course.  
[Read More](http://www.samsa.org.za/faq-s)`,
  },
];

const greetings = [
  "hi",
  "hello",
  "hey",
  "good morning",
  "good afternoon",
  "good evening",
  "how are you",
  "how are you doing",
  "what's up",
  "sup",
  "yo",
];

const Chatbot = () => {
  const [visible, setVisible] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [searchIndexData, setSearchIndexData] = useState([]);
  const [showFaqPanel, setShowFaqPanel] = useState(false);
  const [showAllFaqs, setShowAllFaqs] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [typingDots, setTypingDots] = useState("");
  const chatboxRef = useRef(null);
  const lastGreetingIndex = useRef(null); // To avoid same greeting consecutively

  // --- Fetch search index from backend ---
  useEffect(() => {
    const fetchSearchIndex = async () => {
      try {
        const res = await fetch(`${WebApiURL}Chatbot/searchindex`);
        const data = await res.json();
        const flattened = Array.isArray(data) ? data : Object.values(data).flat();
        setSearchIndexData(flattened);
      } catch (err) {
        console.error("Error fetching search index:", err);
      }
    };
    fetchSearchIndex();
  }, []);

  // --- Initial greeting ---
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        addMessage(
          "bot",
          `Hi, I’m **SAMSA-BOT**, your official assistant for SAMSA.  
How can I assist you today?`
        );
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [visible]);

  // --- Scroll chat to bottom ---
  useEffect(() => {
    chatboxRef.current?.scrollTo(0, chatboxRef.current.scrollHeight);
  }, [messages]);

  // --- Inactivity prompts ---
  useEffect(() => {
    let inactivityTimer;
    let onlinePromptShown = false;
    let awayPromptShown = false;

    const showOnlinePrompt = () => {
      if (!onlinePromptShown) {
        addMessage("bot", "👋 Are you still online? I’m here to assist if you need anything.");
        onlinePromptShown = true;
      }
    };

    const showAwayPrompt = () => {
      if (!awayPromptShown) {
        addMessage(
          "bot",
          "It looks like you’ve been away. Feel free to ask your queries anytime. Thank you!"
        );
        awayPromptShown = true;
      }
    };

    const resetTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(() => {
        if (!onlinePromptShown) {
          showOnlinePrompt();
          inactivityTimer = setTimeout(showAwayPrompt, 30 * 1000);
        } else if (!awayPromptShown) {
          showAwayPrompt();
        }
      }, 30 * 1000);
    };

    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keypress", resetTimer);
    window.addEventListener("click", resetTimer);
    resetTimer();

    return () => {
      clearTimeout(inactivityTimer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keypress", resetTimer);
      window.removeEventListener("click", resetTimer);
    };
  }, []);

  // --- Typing animation ---
  useEffect(() => {
    let dotsInterval;
    if (isTyping) {
      let count = 0;
      dotsInterval = setInterval(() => {
        count = (count + 1) % 4;
        setTypingDots(".".repeat(count));
      }, 500);
    } else {
      setTypingDots("");
    }
    return () => clearInterval(dotsInterval);
  }, [isTyping]);

  const addMessage = (sender, text) => {
    setMessages((prev) => [
      ...prev,
      { sender, text, time: new Date().toLocaleTimeString() },
    ]);
  };

  const updateMessage = (text) => {
    setMessages((prev) => {
      const updated = [...prev];
      if (updated.length > 0) {
        updated[updated.length - 1] = {
          sender: "bot",
          text,
          time: new Date().toLocaleTimeString(),
        };
      }
      return updated;
    });
  };

  const renderMarkdown = (markdown) => {
    const rawHtml = marked.parse(markdown, { breaks: true });
    const htmlWithTarget = rawHtml.replace(
      /<a /g,
      '<a target="_blank" rel="noopener noreferrer" '
    );
    return { __html: DOMPurify.sanitize(htmlWithTarget) };
  };

  const addQueryFormLink = () => {
    addMessage(
      "bot",
      `You can also submit your query via our [Contact Form](/contact-us?section=query-form).`
    );
  };

  const handleSendMessage = () => {
    if (!input.trim()) return;
    const userMessage = input.trim();
    addMessage("user", userMessage);
    handleQuery(userMessage);
    setInput("");
  };

  const handleQuery = async (query) => {
    const normalizedQuery = query.toLowerCase().trim();

    // --- Handle greetings ---
    const isGreeting = greetings.some((greet) =>
      new RegExp(`\\b${greet}\\b`, "i").test(normalizedQuery)
    );

    const greetingReplies = [
      "Hey there! 👋 How can I help you today?",
      "Hi! 😊 I’m SAMSA-BOT, how can I assist you?",
      "Hello! 👋 Great to see you — what would you like to know?",
      "Hey! 😄 Need help with something related to SAMSA?",
      "Hi there! 👋 How can I assist you today?",
    ];

    if (isGreeting) {
      let randomIndex;
      do {
        randomIndex = Math.floor(Math.random() * greetingReplies.length);
      } while (randomIndex === lastGreetingIndex.current);

      lastGreetingIndex.current = randomIndex;
      setTimeout(() => addMessage("bot", greetingReplies[randomIndex]), 400);
      return;
    }

    // --- Typing ---
    setIsTyping(true);
    addMessage("bot", "SAMSA-BOT is typing...");

    try {
      // --- Search index fallback ---
      const searchResults = searchIndexData.filter((item) =>
        (`${item.title || ""} ${item.content || ""} ${item.link || ""}`)
          .toLowerCase()
          .includes(normalizedQuery)
      );

      let aiMessage = "";

      if (searchResults.length > 0) {
        const best = searchResults[0];
        aiMessage = `${best.title ? `**${best.title}**\n\n` : ""}${best.content?.trim()}  
[Read More](${best.link})`;
      } else {
        // --- Call backend AI ---
        const response = await fetch(`${WebApiURL}Chatbot/send`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ message: query }),
        });

        const data = await response.json();
        aiMessage = data?.reply?.trim() || "";

        // --- Clean AI response ---
        aiMessage = aiMessage.replace(/(\[Thinking.*?\]|\[Processing.*?\])/gi, "").trim();

        if (!aiMessage) {
          aiMessage =
            "I'm happy to help with SAMSA-related topics. Could you clarify your question?";
        }
      }

      // --- Update last bot message ---
      updateMessage(`${aiMessage}\n\n_Is there anything else I can help you with?_`);
      addQueryFormLink();
    } catch (error) {
      console.error("SAMSA-BOT error:", error);
      updateMessage("🚨 Something went wrong. Please use our contact form below.");
      addQueryFormLink();
    } finally {
      setIsTyping(false);
    }
  };

  const handleFaqClick = (faq) => {
    addMessage("user", faq.question);
    setShowFaqPanel(false);
    setShowAllFaqs(false);
    setTimeout(() => {
      addMessage("bot", `${faq.answer}\n\n_Is there anything else I can help you with?_`);
    }, 400);
  };

  const visibleFaqs = showAllFaqs ? faqs : faqs.slice(0, 5);

  // --- Styles (kept as your original design) ---
  const styles = {
    chatbotToggle: {
      width: "60px",
      height: "60px",
      backgroundColor: "#009688",
      borderRadius: "50%",
      boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
      backgroundImage: `url(${Chatlogo})`,
      backgroundSize: "contain",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      position: "fixed",
      bottom: "20px",
      right: "20px",
      zIndex: 9999,
      cursor: "pointer",
    },
    chatbot: {
      position: "fixed",
      bottom: "100px",
      right: "20px",
      width: "350px",
      height: "500px",
      background: "white",
      borderRadius: "10px",
      boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
      display: "flex",
      flexDirection: "column",
      zIndex: 9999,
    },
    chatHeader: {
      backgroundColor: "#009688",
      color: "white",
      padding: "10px",
      textAlign: "center",
      fontWeight: "bold",
      position: "relative",
    },
    chatbox: {
      flex: 1,
      padding: "10px",
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    inputArea: {
      display: "flex",
      alignItems: "center",
      padding: "10px",
      borderTop: "1px solid #ddd",
      gap: "10px",
      position: "relative",
    },
    userInput: {
      flex: 1,
      padding: "10px",
      borderRadius: "5px",
      border: "1px solid #ccc",
      fontSize: "14px",
    },
    sendBtn: {
      width: "60px",
      height: "40px",
      backgroundColor: "#009688",
      color: "white",
      border: "none",
      borderRadius: "5px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "14px",
    },
    faqToggleBtn: {
      backgroundColor: "#4CAF50",
      color: "white",
      border: "none",
      borderRadius: "20px",
      padding: "6px 14px",
      cursor: "pointer",
      fontSize: "14px",
      position: "absolute",
      right: "18px",
      bottom: "75px",
    },
    faqPanel: {
      position: "absolute",
      bottom: "50px",
      right: "0",
      width: "100%",
      maxHeight: "200px",
      overflowY: "auto",
      border: "1px solid #ddd",
      borderRadius: "8px",
      background: "#f9f9f9",
      zIndex: 9999,
    },
    faqItem: {
      marginBottom: "8px",
      padding: "8px 12px",
      borderRadius: "8px",
      background: "#eee",
      cursor: "pointer",
      fontWeight: "bold",
      color: "#009688",
    },
  };

  return (
    <>
      {!visible && <div style={styles.chatbotToggle} onClick={() => setVisible(true)} />}
      {visible && (
        <div style={styles.chatbot}>
          <div style={styles.chatHeader}>
            SAMSA-BOT AI Assistant
            <button
              style={{ position: "absolute", top: "5px", right: "10px", background: "none", border: "none", fontSize: "20px", color: "#fff", cursor: "pointer" }}
              onClick={() => setVisible(false)}
            >
              &times;
            </button>
          </div>

          <div style={styles.chatbox} ref={chatboxRef}>
            {messages.map((msg, idx) => {
              const isBot = msg.sender === "bot";
              return (
                <div key={idx} style={{ alignSelf: isBot ? "flex-start" : "flex-end", maxWidth: "80%" }}>
                  {isBot ? (
                    msg.text.includes("SAMSA-BOT is typing") ? (
                      <div style={{ fontStyle: "italic", color: "#888", padding: "4px" }}>
                        SAMSA-BOT is typing{typingDots}
                      </div>
                    ) : (
                      <div style={{ background: "#bfbfbf", padding: "8px", borderRadius: "10px" }} dangerouslySetInnerHTML={renderMarkdown(msg.text)} />
                    )
                  ) : (
                    <div style={{ background: "#009688", color: "white", padding: "8px", borderRadius: "10px" }}>
                      {msg.text}
                    </div>
                  )}
                  <div style={{ fontSize: "10px", color: "#888", marginTop: "2px" }}>{msg.time}</div>
                </div>
              );
            })}
          </div>

          <div style={styles.inputArea}>
            <input
              style={styles.userInput}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
              placeholder="Type your message..."
            />
            <button style={styles.sendBtn} onClick={handleSendMessage}>Send</button>
          </div>

          <button style={styles.faqToggleBtn} onClick={() => setShowFaqPanel(!showFaqPanel)}>
            {showFaqPanel ? "Close FAQs" : "FAQs"}
          </button>

          {showFaqPanel && (
            <div style={styles.faqPanel}>
              {visibleFaqs.map((faq, idx) => (
                <div key={idx} style={styles.faqItem} onClick={() => handleFaqClick(faq)}>{faq.question}</div>
              ))}
              {!showAllFaqs && faqs.length > 5 && (
                <div style={{ ...styles.faqItem, background: "#009688", color: "#fff", textAlign: "center" }} onClick={() => setShowAllFaqs(true)}>See all FAQs</div>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Chatbot;
